import React from "react";
import MainLotto90Wrapper from "../../../components/lotto90/MainLotto90Wrapper";
import Sale from "../../../components/lotto90/mobile/Sale";
import "../../../assets/css/lotto90mobile.css";

const Lotto90Mobile = () => {

    return (
        <div className="main-w">
            <div className="main">
                <div className="w-1200">
                    <div className="lo90-v1-wap wrapper-new-lotto90 lotto90">
                        <MainLotto90Wrapper>
                            <Sale />
                        </MainLotto90Wrapper>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Lotto90Mobile;